<template>
  <div class="is-flex is-align-items-center">
    <!-- FILTER -->
    <master-data-filter :manager="manager" type="design" />
    <table-head-data-design-filter :manager="manager" />

    <!-- EXPECTED PRODUCTION SORT -->
    <sort-arrows
      margin="mr-1"
      :list="manager.list"
      :sorters="{
        asc: 'sortExpectedProductionAscending',
        desc: 'sortExpectedProductionDescending',
      }"
    />
    <data-box v-if="expectedProductionTotal" class="mr-1">
      <span class="data-box-value">kWh: {{ expectedProductionTotal }}</span>
    </data-box>

    <!-- DATA TOTALS -->
    <template v-for="[field, value] in Object.entries(totals)">
      <!-- NESTED DATA -->
      <template v-if="typeof value === 'object'">
        <dropdown-slotted :key="`${field}-${value}`" min-width="0">
          <template v-slot:trigger>
            <data-box class="mr-1">
              <span class="data-box-value">{{ field }}: {{ value.total }}</span>
              <i class="fas fa-angle-down has-text-white ml-1"></i>
            </data-box>
          </template>

          <template>
            <data-box
              v-for="[type, val] in orderFieldsByCount(value.fields)"
              :key="`${type}-${val}`"
              class="has-text-black my-1"
            >
              <span class="data-box-value">{{ type }}: {{ val }}</span>
            </data-box>
          </template>
        </dropdown-slotted>
      </template>

      <!-- FLAT DATA -->
      <data-box v-else :key="`${field}-${value}`" class="mr-1">
        <span class="data-box-value">{{ field }}: {{ value }}</span>
      </data-box>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

import { TASK_TYPE_DESIGN } from '@/constants'
import type { TasksScreenManager } from '@/logic/TasksScreen'

import TableHeadDataDesignFilter from './TableHeadDataDesignFilter.vue'
import MasterDataFilter from './MasterDataFilter.vue'

@Component({
  name: 'TableHeadDataDesign',
  components: {
    TableHeadDataDesignFilter,
    MasterDataFilter,
  },
})
export default class TableHeadDataDesign extends Vue {
  @Prop() manager!: TasksScreenManager

  get expectedProductionTotal() {
    const items = this.manager.list.filteredItems
    const total = items.reduce((sum, item) => {
      const taskData = item.getTaskData(TASK_TYPE_DESIGN)
      const value = parseFloat(taskData.expected_production as string) || 0
      return sum + value
    }, 0)
    return total > 0 ? total : 0
  }

  get totals() {
    const dataFields = ['panels', 'inverters', 'smartmeters', 'batteries']
    const data = this.manager.generateTaskDataStatistics(TASK_TYPE_DESIGN, dataFields)
    return data
  }

  protected orderFieldsByCount(fields: { [field: string]: number }) {
    return Object.entries(fields).sort((a, b) => {
      const valueA = a[1]
      const valueB = b[1]
      return valueB - valueA
    })
  }
}
</script>
